module.exports = {
  sentryEnabled: true,
  recaptchaSiteKey: "6LcvBB0sAAAAABJagBEQ6uhYcr3FANhAoULCmR4a",
  coreApi: {
    protocol: "https",
    host: "api-gcp.ct-production.net",
  },
};
